import { Navigate, Route, Routes, ScrollRestoration } from 'react-router-dom';
import './custom.css';

// import GuestRoutes from './routes/guestRoutes';
import { useAuthStore } from './stores/authStore';
import { Paths } from './routes/paths';
import { AuthStatus } from './types/enums/AuthStatus';
// import MemberRoutes from './routes/memberRoutes';
import AccountBlockedPage from './ui/pages/AccountBlockedPage';
import DemoBlockedPage from './ui/pages/DemoBlockedPage';
import { lazy, Suspense } from 'react';
import Loader from './ui/components/common/Loader';

const MemberRoutes = lazy(() => import('./routes/memberRoutes'));
const GuestRoutes = lazy(() => import('./routes/guestRoutes'));

function App() {
  const isAuthenticated = useAuthStore(
    (state) => state.status === AuthStatus.Authenticated
  );

  return (
    <Suspense fallback={<Loader />}>
      <ScrollRestoration />
      <Routes>
        <Route
          path={Paths.Root}
          element={
            <Navigate
              to={isAuthenticated ? Paths.HomeDashboard : Paths.Login}
              replace
            />
          }
        />

        <Route path={Paths.AccountBlocked} element={<AccountBlockedPage />} />

        <Route path={Paths.DemoBlocked} element={<DemoBlockedPage />} />

        <Route path="/member/*" element={<MemberRoutes />} />

        <Route path="/*" element={<GuestRoutes />} />
      </Routes>
    </Suspense>
  );
}

export default App;
